import { Controller } from "@hotwired/stimulus"

// Keeps a disclosure group intentionally small: opening one panel closes its siblings.
// The summary ARIA state mirrors the native <details> state for assistive technologies.
export default class extends Controller {
  static targets = [ "panel", "summary" ]

  connect() {
    this.#keepOnlyOneOpen()
    this.#syncAria()
  }

  toggle(event) {
    const panel = event.currentTarget

    if (panel.open) {
      this.panelTargets.forEach(otherPanel => {
        if (otherPanel !== panel) otherPanel.open = false
      })
    }

    this.#syncAria()
  }

  #keepOnlyOneOpen() {
    const openPanels = this.panelTargets.filter(panel => panel.open)
    openPanels.slice(1).forEach(panel => { panel.open = false })
  }

  #syncAria() {
    this.summaryTargets.forEach(summary => {
      const panel = summary.closest("details")
      summary.setAttribute("aria-expanded", String(Boolean(panel?.open)))
    })
  }
}
